import { Component, OnInit } from '@angular/core';
import { CrudService } from '../../../crud/crud.service';
@Component({
  selector: 'app-resumen-adeudo',
  templateUrl: './lista.component.html'
})

export class AdeudoComponent{
  tamano = document.body.clientHeight;
  datos = [];
  cargando = false;
  constructor(
    private crudService: CrudService) { }
  
  ngOnInit() {
    document.getElementById('catalogos').click();
  }
}